import React, { useState } from 'react';

interface TeamSelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (teamName: string, teamCode: string) => Promise<void> | void;
}

const TeamSelectModal: React.FC<TeamSelectModalProps> = ({ isOpen, onClose, onSelect }) => {
  const [teamName, setTeamName] = useState('');
  const [teamCode, setTeamCode] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (!teamName.trim() || !teamCode.trim()) return;
    setSubmitting(true);
    try {
      await onSelect(teamName.trim(), teamCode.trim());
      setTeamName('');
      setTeamCode('');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setTeamName('');
    setTeamCode('');
    onClose();
  };

  return (
    <div className="cp-modal-backdrop" onClick={handleClose}>
      <div
        className="cp-modal"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <h3>팀 선택</h3>
        <p className="page-desc">팀 이름과 팀 코드를 입력해 선택하세요.</p>
        <div className="cp-modal-body">
          <input
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            placeholder="팀 이름 입력"
          />
          <input
            value={teamCode}
            onChange={(e) => setTeamCode(e.target.value)}
            placeholder="팀 코드 입력"
          />
        </div>
        <div className="cp-modal-footer">
          <button type="button" className="cp-btn-secondary" onClick={handleClose}>
            닫기
          </button>
          <button
            type="button"
            className="cp-btn-primary"
            onClick={() => {
              void handleConfirm();
            }}
            disabled={!teamName.trim() || !teamCode.trim() || submitting}
          >
            {submitting ? '처리 중...' : '저장'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamSelectModal;

